<div class="flex flex-row pt-2">
  @if (!isMobile) {
    <div class="bg-primary border-md border-primary p-6 w-auto rounded-[10px] flex items-center justify-center mr-2">
      <i class="fa-solid fa-fork-knife text-xl"></i>
    </div>
  }
  <div
    [attr.data-testid]="'qa-addon-checkbox-button-' + dataTestIdSuffix"
    class="relative flex flex-1 h-full w-full items-start p-3 rounded-sm border-md focus:ring-2"
    [ngClass]="{
      'bg-brand-light border-brand': isSelected,
      'bg-primary border-primary': !isSelected || isDisabled,
      'hover:md:bg-primary hover:md:border-md hover:md:border-solid': !isDisabled
    }"
  >
    <span
      sparkCheckbox
      class="after:absolute after:size-full after:inset-0"
      [attr.data-testid]="'qa-addon-checkbox-' + dataTestIdSuffix"
      [disabled]="isDisabled"
      [checked]="isSelected"
      [attr.aria-labelledby]="'addon-label-' + optionValue"
      (checkedChange)="onSelection($event)"
    ></span>

    <div class="ml-3 flex flex-1 justify-between text-left">
      <div class="flex flex-col">
        <span
          class="font-bold text-md leading-md tracking-md"
          [id]="'addon-label-' + optionValue"
          [ngClass]="{ 'text-disabled': isDisabled }"
          >{{ textContent.title }}
        </span>
        <span class="text-xs leading-xs tracking-lg my-2" [innerHtml]="textContent.description"></span>
      </div>
      <div *ngIf="price" class="flex flex-col self-center items-end">
        <span class="font-semibold text-md leading-md tracking-md">
          +
          {{
            price
              | currency
                : currencies.currencySymbol[offerCurrency]
                : 'code'
                : (offerCurrency === currencies.currencyCode.HUF ? '1.0-0' : undefined)
          }}{{ 'listings-property-per-night' | translate }}
        </span>
        <span class="text-xs leading-xs tracking-lg my-2">{{ 'checkout.per-person' | translate }}</span>
      </div>
    </div>
  </div>
</div>
